(function () {
  'use strict';

  var PAUSE_APRES_FERMETURE = 450;

  function voileApplication() {
    return document.querySelector('.xboost-cart-slide');
  }

  function estOuvert(voile) {
    return !!voile && getComputedStyle(voile).display !== 'none';
  }

  function refermerVoileDuTheme() {
    var voile = document.querySelector('.js-overlay');
    if (voile && voile.classList.contains('is-visible')) {
      voile.classList.remove('is-visible');
    }
  }

  function neutraliserIconePanier() {
    var icone = document.getElementById('cart-icon');
    if (!icone) return;
    icone.style.pointerEvents = 'none';
    setTimeout(function () {
      icone.style.pointerEvents = '';
    }, PAUSE_APRES_FERMETURE);
  }

  function surveiller(voile) {
    var ouvertAvant = estOuvert(voile);

    new MutationObserver(function () {
      var ouvertMaintenant = estOuvert(voile);
      if (ouvertAvant && !ouvertMaintenant) {
        refermerVoileDuTheme();
        neutraliserIconePanier();
      }
      ouvertAvant = ouvertMaintenant;
    }).observe(voile, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  function fermerParLaCroix() {
    var croix = document.querySelector(
      '.xb_slide_cart_button_close, .xb_slide_cart_close_button, .xboost-slide-cart-width [class*="_close"]'
    );
    if (croix) croix.click();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (!estOuvert(voileApplication())) return;
    fermerParLaCroix();
  });

  function demarrer() {
    var voile = voileApplication();
    if (!voile) return false;
    surveiller(voile);
    return true;
  }

  if (!demarrer()) {
    var attente = new MutationObserver(function () {
      if (demarrer()) attente.disconnect();
    });
    attente.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

(function () {
  'use strict';

  var ID = 'xb-quantity-breaks-root';
  var ARGENT = /^\s*(\d[\d\s.,]*)\s*€\s*$/;

  function racine() {
    return document.getElementById(ID);
  }

  function paliers() {
    var sources = [
      ((window.quantity_break_data || {}).data_settings || {}).offer,
      ((window.xb_qb_data || {}).a_setting || {}).offer,
      (window.xb_qb_data || {}).offer,
    ];
    for (var i = 0; i < sources.length; i++) {
      var liste = (((sources[i] || {}).discounts) || {}).quantity_breaks;
      if (liste && liste.length) {
        return liste.filter(function (t) {
          return t && t.quantity;
        });
      }
    }
    return [];
  }

  function prixVariante(id) {
    var p = window.xb_upsell_current_product;
    if (p && p.variants) {
      for (var i = 0; i < p.variants.length; i++) {
        if (String(p.variants[i].id) === String(id)) return p.variants[i].price;
      }
    }
    return null;
  }

  function montants(ligne) {
    var out = [];
    ligne.querySelectorAll('*').forEach(function (e) {
      if (e.children.length === 0 && ARGENT.test(e.textContent)) out.push(e);
    });
    return out;
  }

  function ecrire(valeur, modele) {
    var espace = /\s€/.test(modele) ? ' ' : '';
    return valeur.toFixed(2).replace('.', ',') + espace + '€';
  }

  function arrondir(x) {
    return Math.round(x * 100) / 100;
  }

  function quantiteLigne(ligne, palier) {
    var cadre = ligne.parentElement;
    if (!cadre || cadre.querySelectorAll('button').length < 2) return palier.quantity;

    var lu = null;
    cadre.querySelectorAll('*').forEach(function (e) {
      if (lu !== null || e.children.length || ligne.contains(e)) return;
      var t = (e.textContent || '').trim();
      if (/^\d{1,3}$/.test(t)) lu = parseInt(t, 10);
    });
    return lu || palier.quantity;
  }

  function calculer(palier, prix, quantite) {
    if (palier.unit !== '%') return null;
    var q = quantite || palier.quantity;
    var remise = (palier.amount || 0) / 100;
    return { total: arrondir(q * prix * (1 - remise)), plein: arrondir(q * prix) };
  }

  function calculJuste(prix) {
    var w = racine();
    if (!w || !prix) return false;
    var lignes = w.querySelectorAll('label');
    var liste = paliers();
    if (!lignes.length || lignes.length !== liste.length) return false;

    for (var i = 0; i < lignes.length; i++) {
      var attendu = calculer(liste[i], prix, quantiteLigne(lignes[i], liste[i]));
      if (!attendu) return false;
      var vus = montants(lignes[i]);
      if (!vus.length) return false;
      if (ecrire(attendu.total, vus[0].textContent) !== vus[0].textContent.trim()) return false;
    }
    return true;
  }

  function prixParArticle() {
    var w = racine();
    return !!(w && w.querySelector('select'));
  }

  function majPrix(prix) {
    var w = racine();
    if (!w || !prix || prixParArticle()) return;
    var lignes = w.querySelectorAll('label');
    var liste = paliers();

    for (var i = 0; i < lignes.length && i < liste.length; i++) {
      var v = calculer(liste[i], prix, quantiteLigne(lignes[i], liste[i]));
      if (!v) continue;

      montants(lignes[i]).forEach(function (noeud, n) {
        var valeur = n % 2 === 0 ? v.total : v.plein;
        noeud.textContent = ecrire(valeur, noeud.textContent);
      });
    }
  }

  function sortirDuBloc() {
    var w = racine();
    if (!w) return false;
    var bloc = w.closest('.product-info__block');
    if (!bloc) return false;
    if (bloc.classList.contains('cm-xbqb')) return true;
    var hote = document.createElement('div');
    hote.className = 'product-info__block cm-xbqb';
    bloc.parentElement.insertBefore(hote, bloc);
    hote.appendChild(w);
    return true;
  }

  function demarrerPaliers() {
    var w = racine();
    if (!w || !w.querySelector('label')) return false;

    var champ = document.querySelector('.product-info [name="id"], form[action*="/cart/add"] [name="id"]');
    var prix = prixVariante(champ && champ.value);
    var aRecalculer = !prixParArticle() && calculJuste(prix);

    if (!prixParArticle() && !aRecalculer) return true;
    if (!sortirDuBloc()) return true;

    document.addEventListener('on:variant:change', function (e) {
      var v = e.detail && e.detail.variant;

      var p = prixVariante(v && v.id);
      if (!p && v && v.price) p = v.price / 100;
      if (p) majPrix(p);
    });
    return true;
  }

  if (!demarrerPaliers()) {
    var essais = 0;
    var horloge = setInterval(function () {
      essais += 1;
      if (demarrerPaliers() || essais > 40) clearInterval(horloge);
    }, 400);
  }
})();

(function () {
  'use strict';

  var MARQUE = 'cm-xb-icone-image';
  var enAttenteIcone = false;

  function racineTiroir() {
    return document.querySelector('#xboost-upsell-slide-cart-root');
  }

  function retirerMarque(pastille) {
    if (!pastille.hasAttribute('data-cm-icone')) return;
    pastille.classList.remove(MARQUE);
    pastille.removeAttribute('data-cm-icone');
    pastille.style.removeProperty('--cm-xb-icone');
    pastille.style.removeProperty('--cm-xb-icone-taille');
  }

  function poserIcones() {
    var r = racineTiroir();
    if (!r) return;
    var pastilles = r.querySelectorAll('[class*="rewards-bar-foreground-color"]');
    for (var i = 0; i < pastilles.length; i++) {
      var pastille = pastilles[i];
      var img = pastille.querySelector(':scope > img');
      var bibliotheque = pastille.querySelector('.xb-inline-svg');
      var url = img && !bibliotheque ? img.currentSrc || img.getAttribute('src') : null;
      if (!url) {
        retirerMarque(pastille);
        continue;
      }
      if (pastille.getAttribute('data-cm-icone') === url) continue;
      var taille = img.style.width || Math.round(img.getBoundingClientRect().width) + 'px';
      pastille.style.setProperty('--cm-xb-icone', 'url("' + url + '")');
      pastille.style.setProperty('--cm-xb-icone-taille', taille);
      pastille.setAttribute('data-cm-icone', url);
      pastille.classList.add(MARQUE);
    }
  }

  function planifierIcones() {
    if (enAttenteIcone) return;
    enAttenteIcone = true;
    requestAnimationFrame(function () {
      enAttenteIcone = false;
      poserIcones();
    });
  }

  function demarrerIcones() {
    var r = racineTiroir();
    if (!r) return false;
    poserIcones();
    new MutationObserver(planifierIcones).observe(r, { childList: true, subtree: true });
    return true;
  }

  if (!demarrerIcones()) {
    var attenteIcone = new MutationObserver(function () {
      if (demarrerIcones()) attenteIcone.disconnect();
    });
    attenteIcone.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
